import React from 'react';
import { useTranslation } from 'react-i18next';

const TermsPage = () => {
    const { t } = useTranslation();

    return (
        <div className="max-w-3xl mx-auto py-10 px-4">
            <h1 className="text-2xl font-bold mb-6">{t('termsTitle')}</h1>

            <p className="mb-4">{t('termsIntro')}</p>

            <ul className="list-disc pl-5 space-y-2 mb-6">
                <li>{t('termsItem1')}</li>
                <li>{t('termsItem2')}</li>
                <li>{t('termsItem3')}</li>
            </ul>
            <p className="mb-4">{t('termsPayment')}</p>
            <p className="mb-4">{t('termsDuration')}</p>
            <p className="mb-4">{t('termsRefund')}</p>

            <p className="mb-4">{t('termsEUWithdrawal')}</p>

            <p className="text-sm text-gray-600">{t('lastUpdated')}</p>
        </div>
    );
};

export default TermsPage;
